import { Helmet } from "react-helmet";
import { Outlet } from "react-router";

const PublicLayout = () => {
  return (
    <div>
      <Helmet titleTemplate="Kledo Support | %s" title="Kledo Software" />
      <>
        <Outlet />
      </>
    </div>
  );
};

export default PublicLayout;
